import { useCallback, useEffect, useRef } from "react";
import ReloadService from "../../../../service/Reload.service";

const MAX_RETRIES = 10;
const BASE_DELAY_MS = 1000;
const MAX_DELAY_MS = 30000;

/**
 * Custom hook quản lý SSE connection cho ReloadService (stream phiên họp)
 * @param {boolean} shouldConnect - cờ từ redux để quyết định connect
 * @param {function} onData - callback xử lý data, nhận parsed JSON từ SSE
 * @param {string} [key] - idPhienHop để truyền vào SSE endpoint
 * @returns {{ eventSourceRef: React.MutableRefObject }}
 */
export default function useSSEReload(shouldConnect, onData, key) {
    const eventSourceRef = useRef(null);
    const retryCount = useRef(0);
    const retryTimer = useRef(null);

    const cleanup = useCallback(() => {
        if (retryTimer.current) {
            clearTimeout(retryTimer.current);
            retryTimer.current = null;
        }
        if (eventSourceRef.current) {
            eventSourceRef.current.close();
            eventSourceRef.current = null;
        }
    }, []);

    const connect = useCallback(() => {
        cleanup();

        const es = ReloadService.connectSSE(key);

        es.addEventListener("ping", () => {
            // Heartbeat — connection alive
        });

        es.onopen = () => {
            retryCount.current = 0;
        };

        es.onmessage = (event) => {
            try {
                console.log(event)
                const data = JSON.parse(event.data);
                retryCount.current = 0;
                onData(data);
            } catch (err) {
                console.error("SSE Reload parse error:", err);
            }
        };

        es.onerror = () => {
            es.close();
            eventSourceRef.current = null;

            retryCount.current += 1;
            if (retryCount.current <= MAX_RETRIES) {
                const delay = Math.min(
                    BASE_DELAY_MS * Math.pow(2, retryCount.current - 1),
                    MAX_DELAY_MS,
                );
                retryTimer.current = setTimeout(connect, delay);
            } else {
                console.warn("SSE Reload: max retries reached, giving up.");
            }
        };

        eventSourceRef.current = es;
    }, [cleanup, onData, key]);

    useEffect(() => {
        if (shouldConnect) {
            connect();
        }
        return cleanup;
    }, [shouldConnect, connect, cleanup]);

    return { eventSourceRef };
}
